export const BRAND = {
  name: "BW MATRIX",
  fullName: "BW MATRIX",
  tagline:
    "Helping people move better, build stronger bodies, improve athleticism and mobility, and train with confidence.",
  phone: "6474492828",
  phoneDisplay: "(647) 449-2828",
  email: "info@bwmatrix.com",
  location: "Mississauga / Greater Toronto Area",
  serviceArea: "Mississauga / Greater Toronto Area · in person & online",
};

// External Square Appointments booking URL — all "Book" CTAs point here (new tab).
export const SQUARE_BOOKING_URL = "https://app.squareup.com/appointments/book/lnv70ikpvhjp8f/LDDZR7V0MH38K/start";

export const SEO_KEYWORDS = [
  "personal trainer Mississauga",
  "Fascial Stretch Therapy Mississauga",
  "mobility coach GTA",
  "FST Mississauga",
  "mobility training GTA",
  "athletic performance coach Mississauga",
  "assisted stretching Mississauga",
  "joint health training",
];

export const SERVICES = [
  {
    slug: "mobility-assessment",
    number: "01",
    title: "Mobility Assessment",
    short:
      "A joint and movement screen to identify restrictions and build your custom mobility plan.",
    goodFor: "Anyone new to mobility work or coming back from a plateau.",
    options: [
      "Full-body movement screen",
      "Key findings report",
      "Recommended plan + corrective exercises",
    ],
  },
  {
    slug: "personal-training",
    number: "02",
    title: "Personal Training",
    short:
      "1-on-1 strength and movement coaching tailored to your goals and joint health.",
    goodFor: "Strength, fat loss, general fitness, joint-friendly training.",
    options: ["1-on-1 in-person", "Small group", "Online coaching (coming)"],
  },
  {
    slug: "fascial-stretch-therapy",
    number: "03",
    title: "Fascial Stretch Therapy",
    short:
      "Personalized, table-based assisted stretching designed to improve mobility, reduce stiffness, support recovery, and help you move more comfortably.",
    goodFor:
      "Tight hips, back, and shoulders, limited mobility, desk workers, and general recovery.",
    options: ["30 min session", "60 min session"],
  },
  {
    slug: "mobility-strength",
    number: "04",
    title: "Mobility Coaching",
    short:
      "Integrated sessions that fuse mobility work with progressive strength training.",
    goodFor: "Lifters with restrictions. Athletes. People seeking both mobility and strength.",
    options: ["Custom programming", "Session + homework", "Ongoing progressions"],
  },
  {
    slug: "athletic-performance",
    number: "05",
    title: "Athletic Performance Training",
    short:
      "Sport-focused training for power, speed, mobility, and durability.",
    goodFor:
      "Track & field athletes, sprinters, jumpers, throwers, basketball, soccer, volleyball, football, and other field/court athletes.",
    options: ["Speed & power", "Mobility for sport", "Durability & recovery"],
  },
  {
    slug: "corporate-wellness",
    number: "06",
    title: "Corporate Wellness Workshops",
    short:
      "On-site mobility, recovery, and movement workshops for teams — from desk-worker resets to athletic performance seminars.",
    goodFor: "Companies, sports teams, and wellness event organizers.",
    options: [
      "45-min mobility workshop",
      "90-min mobility + FST demo",
      "Custom multi-week programs",
    ],
  },
];

export const CREDENTIALS = [
  { num: "01", label: "Kinesiology background" },
  { num: "02", label: "Fitness & Health Promotion diploma" },
  { num: "03", label: "Mobility specialist certification" },
  { num: "04", label: "FST Level 1 certified" },
  { num: "05", label: "Focus: joint health, mobility, strength, performance" },
];

export const FAQS = [
  {
    q: "What is Fascial Stretch Therapy?",
    a: "Fascial Stretch Therapy (FST) is a table-based, assisted stretching method that targets the fascia and joint capsule to improve mobility, flexibility, circulation, and recovery. It's precise, comfortable, and works with your breath — no forcing.",
  },
  {
    q: "Is FST the same as massage?",
    a: "No. FST is not massage. It is assisted stretching focused on joint capsule and fascial restrictions. It complements massage but has a different scope and toolset.",
  },
  {
    q: "Do I need to be flexible to start?",
    a: "Not at all. Most clients start because they feel stiff or restricted. Sessions are scaled to where your body is today — the goal is to expand what's possible over time.",
  },
  {
    q: "Can I do personal training and FST together?",
    a: "Yes — that combination is one of the most effective ways to unlock mobility and translate it into stronger, more resilient movement.",
  },
  {
    q: "Who is this for?",
    a: "Athletes, lifters, active adults, and anyone who feels stiff or restricted or wants better recovery, joint health, and movement confidence.",
  },
  {
    q: "Do you treat injuries?",
    a: "No. This is a fitness, mobility, and performance service — not medical treatment. If you have an injury or medical concern, I'll refer you to a qualified medical professional.",
  },
];

export const TESTIDS = {
  nav: {
    root: "nav-root",
    home: "nav-link-home",
    about: "nav-link-about",
    services: "nav-link-services",
    book: "nav-link-book",
    faq: "nav-link-faq",
    policies: "nav-link-policies",
    ctaDesktop: "nav-cta-desktop",
    mobileToggle: "nav-mobile-toggle",
    mobileMenu: "nav-mobile-menu",
  },
  hero: {
    cta: "hero-cta-button",
    secondaryCta: "hero-secondary-cta",
  },
  footer: {
    root: "footer-root",
    cta: "footer-cta-button",
    phone: "footer-phone",
  },
  contact: {
    form: "contact-form",
    name: "contact-input-name",
    email: "contact-input-email",
    phone: "contact-input-phone",
    service: "contact-input-service",
    goal: "contact-input-goal",
    availability: "contact-input-availability",
    submit: "contact-submit-btn",
    success: "contact-success-state",
    squareBtn: "contact-square-btn",
  },
  services: {
    card: (slug) => `service-card-${slug}`,
    row: (slug) => `service-row-${slug}`,
  },
  faq: {
    item: (idx) => `faq-item-${idx}`,
  },
  admin: {
    loginForm: "admin-login-form",
    loginEmail: "admin-login-email",
    loginPassword: "admin-login-password",
    loginSubmit: "admin-login-submit",
    dashboard: "admin-dashboard",
    logout: "admin-logout-btn",
    row: (id) => `admin-row-${id}`,
    statusSelect: (id) => `admin-status-${id}`,
    deleteBtn: (id) => `admin-delete-${id}`,
  },
};
